import { render, staticRenderFns } from "./BoxAmounts.vue?vue&type=template&id=c9cbcbea&"
import script from "./BoxAmounts.vue?vue&type=script&lang=js&"
export * from "./BoxAmounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports